import React, { useState, useEffect } from "react";
import { MenuLateral } from "../../../../Components/MenuLateral/Index";
import { Panel } from "../../../../Components/Panel";
import { Header } from "../../../../Components/Header";
import { PerfilInput } from "../../../../Components/PerfilInput";
import { useCartorio } from "../../../../Hooks/cartorio";
import { Alert } from "../../../../Components/Error/Alert";
import {
  Container,
  Formulario,
  HelperInput,
  HandleButton,
  HandleOperationButtons,
  HandleEditarButton,
} from "./styles";
import { DarkButton } from "../../../../Components/DarkButton";
import { validateEmail } from "../../../../Services/validaEmail";
import { validateCPF } from "../../../../Services/validateCPF";
import { limpa_cpf_cnpj } from "../../../../Services/limpa_cpf_cnpj";
import { validateCNPJ } from "../../../../Services/validateCPNJ";
import { limpaMaskCelular } from "../../../../Services/limpaMaskCelular";
import { validaCelular } from "../../../../Services/validaCelular";
import api from "../../../../Services/api";
import { ModalLoader } from "../../../../Components/ModalLoader";
import { EditarSenhaModal } from "../../../../Components/EditarSenhaModal";

export function Perfil() {
  const { cartorio, handleSetCartorio, checarToken } = useCartorio();
  const [NOME, setNome] = useState("");
  const [CPF_CNPJ, setCPF_CNPJ] = useState("");
  const [CPF, setCPF] = useState("");
  const [CNPJ, setCNPJ] = useState("");
  const [EMAIL, setEMAIL] = useState("");
  const [WHATS, setWHATS] = useState("");
  const [FONE, setFONE] = useState("");
  const [loading, setloading] = useState(false);
  const [editarSenhaModal, setEditarSenhaModal] = useState(false);
  const [error, setError] = useState({ message: "", title: "" } as {
    message: string;
    title: string;
  });

  useEffect(() => {
    restoreValues();
  }, [cartorio]);

  function handleSetNome(nNome: string) {
    setNome(nNome);
  }
  function handlesetEMAIL(str: string) {
    setEMAIL(str);
  }
  function handlesetWHATS(str: string) {
    setWHATS(str);
  }
  function handlesetFONE(str: string) {
    setFONE(str);
  }
  function handleSetCpf(str: string) {
    setCPF(str);
  }

  function handleSetCNPJ(str: string) {
    setCNPJ(str);
  }

  function validaForm() {
    if (!validateEmail(EMAIL)) {
      setError({
        message: `O endereço de email digitado não é válido!`,
        title: "Email Inválido!",
      });
      return false;
    }
    if (Number(limpa_cpf_cnpj(CPF)) > 0 && Number(limpa_cpf_cnpj(CNPJ)) > 0) {
      //window.alert(limpa_cpf_cnpj(CPF) + " " + Number(limpa_cpf_cnpj(CNPJ)) )
      setError({
        message: `Não é possível registrar seu cartorio com CNPJ e CPF, preencha um dos dois campos!`,
        title: "Ops",
      });
      return false;
    } else {
      if (Number(limpa_cpf_cnpj(CPF)) > 0)
        if (!validateCPF(limpa_cpf_cnpj(CPF))) {
          setError({
            message: `O CPF digitado não é válido!`,
            title: "CPF Inválido!",
          });
          return false;
        }
      if (Number(limpa_cpf_cnpj(CNPJ)) > 0)
        if (!validateCNPJ(limpa_cpf_cnpj(CNPJ))) {
          setError({
            message: `O CNPJ digitado não é válido!`,
            title: "CNPJ Inválido!",
          });
          return false;
        }
    }

    if (Number(limpaMaskCelular(WHATS)) > 0) {
      if (!validaCelular(limpaMaskCelular(WHATS))) {
        setError({
          message: `O número de celular não é válido!`,
          title: "Celular Inválido!",
        });
        return false;
      }
    }

    if (Number(limpaMaskCelular(FONE)) > 0) {
      if (!validaCelular(limpaMaskCelular(FONE))) {
        setError({
          message: `O número de telefone não é válido!`,
          title: "Telefone Inválido!",
        });
        return false;
      }
    }

    return true;
  }

  async function post() {
    try {
      await checarToken();
      setloading(true);
      const { data } = await api.put(`/cartorio/update`, {
        NOME,
        EMAIL,
        WHATS: limpaMaskCelular(WHATS),
        FONE: limpaMaskCelular(FONE),
        SENHA: cartorio.SENHA,
        CPF_CNPJ:
          limpa_cpf_cnpj(CPF).length == 11
            ? limpa_cpf_cnpj(CPF)
            : limpa_cpf_cnpj(CNPJ),
      });

      handleSetCartorio(data);
      setFormStatus("Visualizar");
    } catch (error) {
      console.log(error);
    } finally {
      setloading(false);
    }
  }

  function restoreValues() {
    setNome(cartorio.NOME);
    setCPF(cartorio.CPF_CNPJ.length == 11 ? cartorio.CPF_CNPJ : "");
    setCNPJ(
      cartorio.CPF_CNPJ.length == 14 ? cartorio.CPF_CNPJ : "00000000000000"
    );
    setEMAIL(cartorio.EMAIL ? cartorio.EMAIL : "exemplo@email.com");
    setWHATS(cartorio.WHATS ? cartorio.WHATS : "00000000000");
    setFONE(cartorio.FONE ? cartorio.FONE : "0000000000");
  }

  const [formStatus, setFormStatus] = useState(
    "Visualizar" as "Visualizar" | "Editar"
  );

  return (
    <Container>
      <MenuLateral titulo={cartorio.NOME} />
      <Panel
        children={
          <>
            <Header type={"PERFIL"} />
            <Formulario>
              <HelperInput>
                <PerfilInput
                  execute={handleSetNome}
                  value={NOME}
                  title={"NOME"}
                  ativo={false}
                  disabled={formStatus == "Visualizar"}
                />
                <PerfilInput
                  execute={handlesetEMAIL}
                  value={EMAIL}
                  title={"EMAIL"}
                  ativo={false}
                  disabled={formStatus == "Visualizar"}
                />
              </HelperInput>
              <HelperInput>
                <PerfilInput
                  execute={handleSetCpf}
                  value={CPF}
                  title={"CPF"}
                  ativo={false}
                  disabled={formStatus == "Visualizar"}
                />
                <PerfilInput
                  execute={handleSetCNPJ}
                  value={CNPJ}
                  title={"CNPJ"}
                  ativo={false}
                  disabled={formStatus == "Visualizar"}
                />
              </HelperInput>
              <HelperInput>
                <PerfilInput
                  execute={handlesetFONE}
                  value={FONE}
                  title={"FONE"}
                  ativo={false}
                  disabled={formStatus == "Visualizar"}
                />
                <PerfilInput
                  execute={handlesetWHATS}
                  value={WHATS}
                  title={"CELULAR"}
                  ativo={false}
                  disabled={formStatus == "Visualizar"}
                />
              </HelperInput>
            </Formulario>
            <HandleButton>
              <HandleEditarButton hidden={formStatus == "Editar"}>
                <DarkButton
                  title={"EDITAR"}
                  execute={() => {
                    console.log(formStatus);
                    setFormStatus("Editar");
                  }}
                />
                <HandleEditarButton hidden={formStatus == "Editar"}>
                  <DarkButton title={"EDITAR SENHA"} execute={() => { setEditarSenhaModal(true)}} />
                </HandleEditarButton>{" "}
              </HandleEditarButton>

              <HandleOperationButtons hidden={formStatus == "Visualizar"}>
                <DarkButton
                  title={"CANCELAR"}
                  execute={() => {
                    console.log(formStatus);
                    restoreValues();
                    setFormStatus("Visualizar");
                  }}
                />
              </HandleOperationButtons>
              <HandleOperationButtons hidden={formStatus == "Visualizar"}>
                <DarkButton
                  title={"SALVAR"}
                  execute={() => {
                    if (validaForm()) {
                      post();
                    }
                  }}
                />
              </HandleOperationButtons>
            </HandleButton>

            <Alert
              open={error.message.length > 0}
              onClose={() => setError({ message: "", title: "" })}
              message={error.message}
              title={error.title}
            />
            <EditarSenhaModal
              open={editarSenhaModal}
              onClose={() => setEditarSenhaModal(false)}
              cartorio={cartorio}
            />
            <ModalLoader loading={loading} />
          </>
        }
      />
    </Container>
  );
}
